import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import { mapActivityData } from 'utils/activities'
import {
  addArray as addActivitiesArray,
  setLoadStatus,
  setCursor
} from '../redux/userActivities'

export default function * fetchUserActivities (action) {
  yield put(setLoadStatus({
    isLoading: true,
    isLoaded: false
  }))

  const state = yield select()

  const userId = state.kanbo.userActivities.userId
  const cursor = state.kanbo.userActivities.cursor

  let args = {
    userId,
    limit: 20
  }

  if (cursor) {
    args.cursor = cursor
  }

  try {
    const { Activities, Cursor } = yield call(apiGetData, 'ActivitiesByUser', args)

    yield put([
      addActivitiesArray(Activities.map(Activity => mapActivityData(Activity))),
      setLoadStatus({
        isLoading: false,
        isLoaded: !Cursor
      }),
      setCursor(Cursor)
    ])
  } catch (error) {
    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))
  }
}
